import React from 'react';
import styled from '@emotion/styled';
import RSInput, { InputProps as RSInputProps } from 'reactstrap/lib/Input';
import { primaryFontFamily } from '../../../styles/fonts';

export type StyledInputProps = RSInputProps & {
  fluid?: boolean;
};

export const StyledInput = styled(
  ({ fluid, type, ...props }: StyledInputProps) => (
    <RSInput type={type} {...props} />
  ),
)<StyledInputProps>`
  height: 56px;
  width: ${({ fluid = false }) => (fluid ? '100%' : 'auto')};
  padding: 0 14px;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.default.colors.n2};

  color: ${({ theme }) => theme.default.colors.n5};

  ${primaryFontFamily}
  font-size: 14px;
  font-style: normal;
  font-weight: normal;

  ${({ type }) =>
    type === 'textarea'
      ? `
        height: auto;
        padding: 15px 14px;
      `
      : ''}

  &:focus,
  &:focus,
  &[type]:focus {
    border-color: ${({ theme }) => theme.default.primaryColor};
    outline: none;
    box-shadow: ${({ theme }) => `0 0 0 1px ${theme.default.primaryColor}`};

    :-webkit-autofill {
      /* Remove the blue background */
      -webkit-box-shadow: 0 0 0px 1000px white inset;
    }
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    opacity: 1; /* Firefox */
    color: ${({ theme }) => theme.default.colors.n3};
  }

  :-webkit-autofill {
    /* Remove the blue background */
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ theme }) => theme.default.colors.n3};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${({ theme }) => theme.default.colors.n3};
  }

  &.is-invalid {
    border-color: ${({ theme }) => theme.default.colors.Feedback.Error};
  }

  /* Remove arrows for inputs with type number */
  &[type='number'] {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    -moz-appearance: textfield;
  }
`;
